import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import confetti from 'canvas-confetti';
import { CotizacionService } from 'src/app/servicios/cotizacion.service';

@Component({
  selector: 'app-red-activa',
  templateUrl: './red-activa.component.html',
  styleUrls: ['./red-activa.component.css']
})
export class RedActivaComponent implements OnInit {
cotizacionVisible = false;
  cotizadorForm: FormGroup;
  step = 0;
  submitted = false;
  mensajeError: string = '';
  yaSeLanzoConfeti = false;
  ciudades: any[] = [];
  destinos: any[] = [];
  precioCotizacion: string = '';

  origenSeleccionado: string = '';
  destinoSeleccionado: string = '';
  direccionSucursal: any = null;

   constructor(private fb: FormBuilder ,   private cotizacionService: CotizacionService) {
    this.cotizadorForm = this.fb.group({
      origen: ['', Validators.required],
      destino: ['', Validators.required],
      largo: ['', [Validators.required, Validators.min(1)]],
      alto: ['', [Validators.required, Validators.min(1)]],
      ancho: ['', [Validators.required, Validators.min(1)]],
      peso: ['', [Validators.required, Validators.min(1)]],
      nombre: ['', Validators.required],
      correo: ['', [Validators.required, Validators.email]],
      celular: ['', [
      Validators.required,
      Validators.pattern(/^\d{10}$/) // Exactamente 10 dígitos
    ]]
    }) ;
    
  }

  ngOnInit(): void {

 // Cargar origenes al iniciar
  this.cotizacionService.getOrigenesVolaris().subscribe({
    next: (data: any) => this.ciudades = data,
    error: (err) => console.error('Error al cargar sucursales', err)
  });

  // Escuchar cambios del campo "origen"
  this.cotizadorForm.get('origen')?.valueChanges.subscribe(origen => {
    if (origen) {
      this.cotizacionService.getDestinosVolaris(origen).subscribe({
        next: (data: any) => this.destinos = data,
        error: (err) => console.error('Error al cargar destinos', err)
      });
    } else {
      this.destinos = [];
    }

    // Limpiar destino seleccionado si se cambia el origen
    this.cotizadorForm.get('destino')?.setValue('');
  });
  
  }

  ngAfterViewChecked() {
  if (this.step === 3 && !this.yaSeLanzoConfeti) {
    this.lanzarConfeti();
    this.yaSeLanzoConfeti = true;
  }
}

mostrarCotizacion() {
  // Paso 1: Oculta con animación (se aplica clase fade-out)
  this.cotizacionVisible = false;

  // Paso 2: Esperar a que la animación termine (0.5s como tu CSS)
  setTimeout(() => {
    // Limpieza y reinicio
    this.cotizadorForm.reset();
    this.cotizadorForm.patchValue({
      origen: '',
      destino: '',
      tipoEnvio: '',
      nombre: '',
      correo: '',
      celular: '',
      largo: '',
      alto: '',
      ancho: '',
      peso:''
    });

    this.submitted = false;
    this.yaSeLanzoConfeti = false;
    this.step = 1;
    this.mensajeError = '';

    // Paso 3: Mostrar nuevamente con fade-in
    this.cotizacionVisible = true;
  }, 0); // coincide con tu transición CSS
  
}

 nextStep() {
    // if (this.step === 1 && this.cotizadorForm.get('origen')?.valid && this.cotizadorForm.get('destino')?.valid && this.cotizadorForm.get('largo')?.valid && this.cotizadorForm.get('alto')?.valid && this.cotizadorForm.get('ancho')?.valid && this.cotizadorForm.get('nombre')?.valid && this.cotizadorForm.get('correo')?.valid && this.cotizadorForm.get('celular')?.valid) {
    //   this.step++;
     if (this.step === 1 ) {
      this.step++;
      
    } else if (this.step >= 2 ) {
      this.step++;
    }
  }

  prevStep() {
    if (this.step >= 1) {
      this.step--;
    }
  }

solicitarCotizacion() {
  this.submitted = true;

  if (this.cotizadorForm.valid) {
    this.mensajeError = '';
    const form = this.cotizadorForm.value;

    this.origenSeleccionado = this.obtenerNombreSucursal(this.ciudades, form.origen);
    this.destinoSeleccionado = this.obtenerNombreSucursal(this.destinos, form.destino);

    this.cotizacionService.getCotizacionVolaris(
      form.origen,
      form.destino,
      form.largo,
      form.alto,
      form.ancho,
      form.peso,
      form.nombre,
      form.correo,
      form.celular // "celular" en el formulario corresponde al teléfono
    ).subscribe({
      next: (data: any) => {
        if (data && data.length && data[0].mensaje === 'Ok') {
          this.precioCotizacion = data[0].precio;

          // Cargar la dirección del origen
          this.cotizacionService.getDireccionOrigen(form.origen).subscribe({
            next: (direccionData: any) => {
              if (direccionData && direccionData.length) {
                this.direccionSucursal = direccionData[0];
              }
              this.nextStep(); // Solo avanza después de cargar todo
            },
            error: err => {
              console.error('Error al cargar dirección', err);
              this.mensajeError = 'Error al obtener la dirección de la sucursal.';
            }
          });

        } else {
          this.mensajeError = data[0].mensaje;
        }
      },
      error: err => {
        console.error('Error al obtener cotización', err);
        this.mensajeError = 'Ocurrió un error al obtener la cotización.';
      }
    });

  } else {
    this.mensajeError = 'Capture todos los campos y verifique que sean válidos.';
  }
}

//   ciudades = [
//   { sucursal: 'CDMX Centro' },
//   { sucursal: 'Aguascalientes' },
//   { sucursal: 'Monterrey' },
// ];

tiposEnvio = [
  { value: 'kg', label: 'Por peso (kg)' },
  { value: 'sobre', label: 'Sobre' },
  { value: 'caja', label: 'Caja' }
];

ChangedOrigen(event: any) {
  console.log('Origen seleccionado:', event);
}

ChangedDestino(event: any) {
  console.log('Destino seleccionado:', event);
}

reiniciarCotizador() {
  this.cotizadorForm.reset();
  this.submitted = false;
  this.step = 0;
  this.mensajeError = '';
  this.yaSeLanzoConfeti = false;
}

realizarOtraCotizacion() {
  // Paso 1: Ocultar contenedor de cotización
  this.cotizacionVisible = false;
  this.reiniciarCotizador();
}


lanzarConfeti() {
  const duration = 5 * 1000; // duración total: 5 segundos
  const animationEnd = Date.now() + duration;

  const interval = setInterval(() => {
    // Si ya pasó el tiempo, detener
    if (Date.now() > animationEnd) {
      clearInterval(interval);
      return;
    }

    // Lanzar confeti desde dos lados (izquierda y derecha)
    confetti({
      particleCount: 100,
      spread: 100,
      origin: { x: Math.random(), y: Math.random() * 0.6 },
      gravity: 0.7
    });
  }, 250); // cada 250ms
}

// obtenerCotizacion() {
//   this.submitted = true;

//   if (this.cotizadorForm.invalid) {
//     this.mensajeError = 'Completa todos los campos correctamente.';
//     return;
//   }

//   const form = this.cotizadorForm.value;
//   const peso = 0;

//   this.cotizacionService.getCotizacionVolaris(
//     form.origen,
//     form.destino,
//     form.largo,
//     form.alto,
//     form.ancho,
//     peso
//   ).subscribe({
//     next: (data: any) => {
//       if (data && data.length && data[0].mensaje === 'Ok') {
//         const precio = data[0].precio;
//         console.log('Precio:', precio);
//         // Aquí puedes asignar el precio a una variable para mostrarlo en pantalla
//          this.precioCotizacion = precio;
//       } else {
//         this.mensajeError = 'No se pudo obtener la cotización.';
//       }
//     },
//     error: err => {
//       console.error('Error al obtener cotización', err);
//       this.mensajeError = 'Ocurrió un error al obtener la cotización.';
//     }
//   });
// }
obtenerNombreSucursal(lista: any[], clave: string): string {
  const item = lista.find(ciudad => ciudad.clave === clave || ciudad.sucursal === clave);
  return item ? item.sucursal : '';
}
}
